import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import FormDialog from "../FormDialog/FormDialog"
import db from "../../../../db"
import { toast } from 'react-toastify';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },

}));

const Toolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const [op, setOp] = useState(false)
  const [orderNumber, setOrderNumber] = useState()
  const [orderDate, setOrderDate] = useState()
  const [customer, setCustomer] = useState()
  const [customerData, setCustomerData] = useState([])
  const [deadline, setDeadline] = useState(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate())
  const [shortCode, setShortCode] = useState()
  const [shortCodeData, setShortCodeData] = useState([])
  const [model, setModel] = useState("")
  const [country, setCountry] = useState("")
  const [sizes, setSizes] = useState()
  const [startOrders, setStartOrders] = useState([])
  const [finalOrders, setFinalOrders] = useState([])
  const [canceledOrders, setCanceledOrders] = useState([])



  const fields =
  {
    orderNumber: {
      value: orderNumber,
      func: setOrderNumber
    },
    customer: {
      value: customer,
      func: setCustomer,
      data: customerData
    },
    deadline: {
      value: deadline,
      func: setDeadline
    },
    orderDate: {
      value: orderDate,
      func: setOrderDate
    },
    shortCode: {
      value: shortCode,
      func: setShortCode,
      data: shortCodeData
    },
    model: {
      value: model,
      func: setModel
    },
    country: {
      value: country,
      func: setCountry
    },
    sizes: {
      value: sizes,
      func: setSizes
    },
    startOrders: {
      value: startOrders,
      func: setStartOrders
    },
    finalOrders: {
      value: finalOrders,
      func: setFinalOrders
    }
  }

  const handleAdd = () => {
    if (startOrders.length === 0) {
      toast.error('Լրացրեք պատվերի մանրամասները')
      return
    }
    if (orderNumber && customer && deadline && shortCode && model && country) {
      const dd = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      db.ref().child('Orders').push({
        orderNumber: orderNumber,
        shortCode: shortCode,
        customer: customer,
        orderDate: dd,
        deadline: deadline,
        model: model,
        country: country,
        startOrders: startOrders,
        finalOrders: startOrders,
        canceledOrders: canceledOrders
      }).then(() => {
        setOrderNumber()
        setShortCode()
        setCustomer()
        setOrderDate()
        setDeadline()
        setModel()
        setCountry()
        setStartOrders([])
        setFinalOrders([])
        toast.success('Ավելացված է');
        setOp(false)
      })
    } else {
      toast.error('Լրացրեք բոլոր դաշտերը')
    }
  }

  const handleOpen = () => {
    setOp(true)

    db.ref('Product').on('value', snap => {
      if (snap.val()) {
        setShortCodeData(snap.val())
      }
    })
    db.ref('InfoCenter/Partners').on('value', snap => {
      if (snap.val()) {
        const a = snap.val()
        let arr = []
        Object.keys(a).map(el => {
          if (a[el].type == "Հաճախորդ") {
            arr.push(a[el])
          }
        })
        setCustomerData(arr)
      } else {
        setCustomerData([])
      }
    })
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <h2>Պատվերներ</h2>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Button
          color="primary"
          variant="contained"
          onClick={handleOpen}
          style={{ marginBottom: "10px" }}
        >
          Ավելացնել
                        </Button>
        <FormDialog op={op} setOp={setOp} title="Ավելացնել պատվեր" func={handleAdd} fields={fields} />
      </div>

    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
